import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useUser } from "../UserContext";
import { Form, Button, Container, Row, Col, Card, Alert } from "react-bootstrap";
import { updateUserDetails } from "../api/api";

const Profile = () => {
    const { user, setUser } = useUser();
    const [formData, setFormData] = useState({
        username: user.username,
        email: user.email,
        current_password: '',
        new_password: '',
        confirm_password: '',
    });

    const [message, setMessage] = useState(null); // for success/error message

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // basic client-side validation
        if (formData.new_password && formData.new_password !== formData.confirm_password) {
            setMessage({ type: 'danger', text: 'New password and confirm password do not match' });
            return;
        }
        try {
            const updatedUser = await updateUserDetails(formData);
            setUser(updatedUser);
            setMessage({ type: 'success', text: 'Profile updated successfully' });
            // clear password fields
            setFormData({
                ...formData,
                current_password: '',
                new_password: '',
                confirm_password: '',
            });
        } catch (error) {
            console.error('Error updating profile:', error);
            setMessage({ type: 'danger', text: 'Error updating profile. Please try again later.' });
        }
    };

    // return (
    //     <div className="profile">
    //         <h2>User Profile</h2>
    //         <form onSubmit={handleSubmit}>
    //             <div>
    //                 <label htmlFor="username">Username:</label>
    //                 <input
    //                     type="text"
    //                     name="username"
    //                     value={formData.username}
    //                     onChange={handleChange}
    //                     required
    //                 />
    //             </div>
    //             <div>
    //                 <label htmlFor="email">Email:</label>
    //                 <input
    //                     type="email"
    //                     name="email"
    //                     value={formData.email}
    //                     onChange={handleChange}
    //                 />
    //             </div>
    //             <div>
    //                 <label htmlFor="first_name">First Name:</label>
    //                 <input
    //                     type="text"
    //                     name="first_name"
    //                     value={formData.first_name}
    //                     onChange={handleChange}
    //                 />
    //             </div>
    //             <div>
    //                 <label htmlFor="last_name">Last Name:</label>
    //                 <input
    //                     type="text"
    //                     name="last_name"
    //                     value={formData.last_name}
    //                     onChange={handleChange}
    //                 />
    //             </div>
    //             <button type="submit">Update Profile</button>
    //         </form>
    //     </div>
    // );

    return(
        <Container className="d-flex justify-content-center align-items-center vh-100 vw-100">
            <Row>
                <Col>
                    <Card className="p-4">
                        <Card.Body>
                            <Card.Title className="text-center mb-4">Profile</Card.Title>
                            {message && <Alert variant={message.type}>{message.text}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formUsername">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <hr />
                                <Form.Group className="mb-3" controlId="formCurrentPassword">
                                    <Form.Label>Current Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="current_password"
                                        value={formData.current_password}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formNewPassword">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="new_password"
                                        value={formData.new_password}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formConfirmPassword">
                                    <Form.Label>Confirm New Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="confirm_password"
                                        value={formData.confirm_password}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Button className="w-100" variant="success" type="submit">
                                    Update Profile
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
};

export default Profile;